export default "__VITE_ASSET__e16ed197__"